export const SET_FISCAL_YEAR = (state, payload) => {
    window.localStorage.setItem('_currentFiscalYear', JSON.stringify(payload));
    state.selectedFiscalYear = payload;
};

export const SET_FISCAL_YEARS_ALL = (state, payload) => {
    state.fiscalYears = payload;
};